import { Box, Grid, Paper } from "@mui/material";
import { ElevatedPaperStyle } from "lib/styles/shared";
import { StepButtonWrapper } from "lib/styles/button";
import { FileUploadPane } from "./FileUploadPane";

interface uploadStepLayoutProps {
	leftPane: React.ReactNode;
	buttons: React.ReactNode;
}

export function UploadStepLayout({ leftPane, buttons }: uploadStepLayoutProps): React.JSX.Element {
	return (
		<Box sx={{ width: "100%" }}>
			<Paper elevation={0} sx={ElevatedPaperStyle}>
				<Grid container spacing={3} alignItems="stretch">
					<Grid item xs={12} md={6} sx={{ display: "flex" }}>
						{leftPane}
					</Grid>
					<Grid item xs={12} md={6} sx={{ display: "flex" }}>
						<FileUploadPane />
					</Grid>
				</Grid>

				<Box sx={StepButtonWrapper}>
					{buttons}
				</Box>
			</Paper>
		</Box>
	);
}
